// bd-deepcontext-b4zw — job / run status derivation lifted out of
// ScheduledJobs.tsx. Kept JSX-free so it is unit-testable; the matching icons
// live in ./statusIcons.tsx.
import type { ScheduledJob } from "./types";

export type JobStatusKind = "running" | "expired" | "active" | "inactive";

export interface JobStatusMeta {
  kind: JobStatusKind;
  text: string;
  className: string;
}

export const isJobExpired = (job: Pick<ScheduledJob, "endDate">): boolean => {
  if (!job.endDate) return false;
  const today = new Date().toISOString().split("T")[0];
  const endDate = new Date(job.endDate).toISOString().split("T")[0];
  return today > endDate;
};

// bd-deepcontext-ikwv — the table itself no longer renders these as badges
// (option B: no Status column; running gets a spinner in the Schedule cell,
// inactive/expired rows are just grayed out with no pill). Kept for tests
// that still exercise the kind/text pairing.
export const getJobStatusMeta = (
  job: Pick<ScheduledJob, "endDate" | "isActive" | "hasRunningJob">,
): JobStatusMeta => {
  if (job.hasRunningJob) {
    return {
      kind: "running",
      text: "Running",
      className: "text-accent bg-nav-active",
    };
  }

  if (isJobExpired(job)) {
    return {
      kind: "expired",
      text: "Expired",
      className: "text-risk bg-risk-bg",
    };
  }

  if (job.isActive) {
    return {
      kind: "active",
      text: "Active",
      className: "text-safe bg-safe-bg",
    };
  }

  return {
    kind: "inactive",
    text: "Inactive",
    className: "text-ink-muted bg-ghost-bg",
  };
};

export const getRunStatusColor = (status: string): string => {
  switch (status) {
    case "pending":
      return "text-warn bg-warn-bg";
    case "running":
      return "text-accent bg-nav-active";
    case "completed":
      return "text-safe bg-safe-bg";
    case "failed":
      return "text-risk bg-risk-bg";
    default:
      return "text-ink-muted bg-ghost-bg";
  }
};
